import { Link, useParams } from "react-router";
import { PageTitle } from "../components/Heading";

export default function Detail() {
  const { id } = useParams<{ id: string }>();

  return (
    <section className="space-y-4">
      <PageTitle>Detail</PageTitle>
      <p className="text-sm text-neutral-400">
        Route param: <span className="font-mono text-neutral-200">{id}</span>
      </p>
      <Link to="/" className="btn btn-ghost btn-sm">
        Back
      </Link>
    </section>
  );
}
